import { Box, Typography } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { partnersInnovations } from "src/utils/dataHomePage";
import DtcLogo from "../../assets/dtclogo.png";

function PartnersSection() {
  return (
    <>
      <Box display="flex" flexDirection={{ lg: "row", xs: "column" }} justifyContent="space-evenly" alignItems="center">
        <Typography
          width={{ lg: "500px", xs: "auto" }}
          variant="h5"
          textAlign="center"
          fontSize={{ lg: "30px", xs: "18px" }}
          p={2}
          color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
          lineHeight={1}
          fontFamily="Oswald, Arial"
        >
          "RotoGPT is a game-changing innovation that propelled us way ahead of our competition."
        </Typography>
        <Box
          sx={{
            pt: { lg: 0, xs: 2 },
            "& img": {
              width: { xs: "120px", lg: "160px" },
              height: "auto",
            },
          }}
        >
          <img src={DtcLogo} alt="RotoGPT" />
        </Box>
      </Box>
      <Typography
        variant="h4"
        textAlign="center"
        sx={{
          pt: { lg: 10, xs: 5 },
          pb: { lg: 5, xs: 5 },
          fontFamily: "Oswald, Arial",
          fontSize: { lg: "38px", xs: "25px" },
          color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
        }}
      >
        PARTNERS IN INNOVATION
      </Typography>

      <Box display="flex" flexDirection="column" alignItems="center" sx={{ pb: { lg: 5, xs: 0 } }}>
        <Box pl={{ lg: 20, sm: 10, md: 15, xs: 0 }} width={{ xs: "90%", sm: "70%", md: "65%", lg: "70%" }}>
          {partnersInnovations.map((partner) => (
            <Box key={partner.id} display="flex" flexDirection={{ lg: "row", sm: "row", xs: "column" }} alignItems="center" justifyContent="center" pb={3}>
              <Box
                sx={{
                  pb: { lg: 0, sm: 0, xs: 2 },
                  pr: { lg: 5, sm: 5, xs: 0 },
                  verticalAlign: "center",
                  "& img": {
                    width: { xs: "150px", lg: "200px" },
                    height: "auto",
                  },
                }}
              >
                <img src={partner.img} alt="RotoGPT" />
              </Box>

              <Box flex="1">
                <Typography
                  variant="h3"
                  sx={{
                    color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                    fontFamily: "Oswald, Arial",
                    fontSize: { lg: "20px", sm: "18px", xs: "16px" },
                    textAlign: { lg: "left", sm: "left", xs: "center" },
                  }}
                >
                  {partner.title}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}

export default PartnersSection;
